//Hooks
import useScrollTop from '../hooks/useScrollTop'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'
//Components
import OperatorsGallery from '../components/OperatorsGallery'
import Map from '../components/Contact/Map'
import ContactInfo from '../containers/Contact/ContactInfo'
//Intersection
import { useInView } from 'react-intersection-observer'

import Translate from '../i18n/Translate'

const Contact = () => {
    useScrollTop()
    useSetI18nProviderInformation('contact')

    const [contactTop, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <main className="incoming-contact">
            <section className="incoming-contact__top">
                <div className={`content animate slide-title ${inView ? 'in-view' : ''}`} ref={contactTop}>
                    <h1 className="title top-title">
                        <Translate langkey="contact.title" />
                    </h1>
                    <p className="copy top-subtitle">
                        <Translate langkey="contact.subtitle" />
                    </p>
                </div>
            </section>

            <ContactInfo />

            <Map />

            <OperatorsGallery />
        </main>
    )
}

export default Contact
